<template>
    <div class="dropdown-menu dropdown-apps pt-0" aria-labelledby="dropdownShortcutMenu" style="top: 15px !important;border:none !important">
        <div class="notification-bg pb-2">
            <div class="d-flex justify-content-end align-items-center pr-2 pt-1">
                <span class="ml-2 pointer mb-1">
                    <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/close_filter.svg" alt="">
                </span>
            </div>
            <div class="px-2">
                <span class="fs-20 fw-500 text-white">Recent Notifications ({{ total }})</span>
            </div>
            <div class="drop-list" id="lazy-load-notify">
                <div class="" v-if="ajaxcall">
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                </div>
                <div class="text-white text-center font-weight-bold fs-16 p-2" v-if="!list.length && !ajaxcall">
                    No Notifications Found
                </div>
                <div v-else class="notification-list mx-2 p-2 mt-2" v-for="item in list" :key="item.notification_id">
                    <div class="d-flex align-items-center flex-column flex-sm-row">
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <img :src="item.profile_pic" v-if="item.profile_pic" :alt="item.message" style="height:50px;width:50px;margin-bottom:3px;margin-right:2px;border-radius:50px;">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" v-else :alt="item.message" style="height:50px;width:50px;margin-bottom:3px;margin-right:2px;border-radius:50px;">
                        </div>  
                        <div class="col-lg-10 col-md-10 col-sm-10">
                            <div class="ml-2"> <span class="fw-500 text-dark text-capitalize">{{item.message}}</span></div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end align-items-center fs-12">{{item.created_time}}</div>
                </div>
                <div class="" v-if="loading" id="spinner">
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center pointer mt-1" @click="showAll()">
            <span class="text-secondary fw-600 fs-14">Show All</span>
        </div>
    </div>
</template>
<script>
import {EventBus} from "../eventBus/nav-bar-event.js";
import notification from '../mixins/notification.js';
export default {
    mixins:[notification],
    data(){
        return{
            skip:0,
            limit:10,
            search_key:'',
            list:[],
            ajaxcall:false,
            total:0,
            count:0,
            loading:false,
            infinite_scroll_reached_end:false,
        }
    },
    methods:{
        showAll(){
            // this.$router.push({ name: "AllNotifications" });
            this.$router.push({name: 'NotificationsPage'})
        },
        async getNotification(){
            try {
                this.ajaxcall = true
                let params ={
                    skip: this.skip,
                    limit: this.limit,
                    search_key:this.search_key.trim()
                }
                let res = await this.getNotificationList(params)
                this.list = res.response.notifications
                this.total = res.response.count
                this.count = this.list.length
                this.ajaxcall = false
            } catch (reason) {
                
            }
        },
        infinteScroll() {
            var scrollTop = document.getElementById('lazy-load-notify').scrollTop
            var scrollHeight = document.getElementById('lazy-load-notify').scrollHeight
            var offsetHeight = document.getElementById('lazy-load-notify').offsetHeight
            var clientHeight = document.getElementById('lazy-load-notify').clientHeight
            var contentHeight = scrollHeight - offsetHeight
            if (contentHeight == scrollTop) {
                if (!this.infinite_scroll_reached_end) {
                    this.infinite_scroll()
                }
            }
        },
        async infinite_scroll() {
            try {
                this.loading = true
                let params ={
                    skip: this.count,
                    limit: this.limit,
                    search_key:this.search_key.trim()
                }
                let res = await this.getNotificationList(params)
                if (res.response.skip == this.count) {
                    let tempFiles = res.response.notifications
                    tempFiles.forEach(el => {
                        this.list.push(el)
                    })
                    this.count += res.response.notifications.length
                    this.loading = false
                }
                if (res.response.notifications.length < 10) {
                    this.infinite_scroll_reached_end = true
                    document.getElementById('spinner').style.display = 'none'
                    this.loading = false
                }
            } catch (reason) {
                
            }
        },
    },
    mounted(){
        this.getNotification()
        EventBus.$on('RecallNotification', () => {
            this.getNotification()
        })
        document.getElementById('lazy-load-notify').addEventListener('scroll', this.infinteScroll, false)
    }
}
</script>
<style scoped>
#lazy-load-notify {
    height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE 11 */
    scrollbar-width: none; /* Firefox 64 */
    overscroll-behavior: contain;
}
#lazy-load-notify::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    overscroll-behavior: contain;
}
.notification-bg{
    background-color: #005dae;
}
.notification-list{
    background-color: #ffffff;
    border-radius: 4px;
}
.drop-list{
    min-height: 195px;
    max-height: 200px;
    overflow: scroll;
}
</style>